

import { useTableColumnsFactibilidadCorporativa, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { Grid, IconButton, Tooltip, } from '@mui/material';
import {
  ROUTER_PATHS, TABLE_CONSTANTS,
} from '@/shared';
import { useNavigate } from 'react-router-dom';
import { Visibility } from '@mui/icons-material';
import { useFetchGetfactibilidadCorporativos } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';
import { useState } from 'react';



interface TableCustomFilterFactibilidadProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  paramsFilter?: Partial<IFactibilidadCorporativo>
}

export default function TableCustomFilterFactibilidad({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  paramsFilter
}: TableCustomFilterFactibilidadProps) {
  // useCheckPermissionsArray([
  //   PermissionsEnum.api_view_preventa,
  //   PermissionsEnum.api_change_preventa
  // ]);

  const navigate = useNavigate();
  const [rowSelection, setRowSelection] = useState({})

  ///* Hook
  const {
    columnsFactibilidad
  } = useTableColumnsFactibilidadCorporativa();

  ///* Fetch


  ///* Hook

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: dataFactibilidadCorporativa,
    isRefetching
  } = useFetchGetfactibilidadCorporativos(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      ...paramsFilter
    }
  );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IFactibilidadCorporativo>
            columns={columnsFactibilidad}
            data={dataFactibilidadCorporativa?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataFactibilidadCorporativa?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            //
            enableRowSelection
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            pinLeftColumnIndexes={[0,1,2]}
            enableSelectAll
            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn='first'
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}

            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                    <Grid item >
                      <Tooltip placement='top' title='Ver Factibilidad Corporativa'>
                        <IconButton
                          onClick={() => {
                            //navigate(`${ROUTER_PATHS.ventas.preventaCorporativoViewNav}/${value.id_preventa_coorporativa}/${value.prospecto_data.id_prospecto}`);
                            navigate(`${ROUTER_PATHS.noc.factibilidadCorporativoNav}/visualizar/${value.id_factibilidad_coorporativa}`);

                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

    </>
  );


}

